import { render, staticRenderFns } from "./viral_stat.vue?vue&type=template&id=d3f8c076&scoped=true&"
import script from "./viral_stat.vue?vue&type=script&lang=js&"
export * from "./viral_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f8c076",
  null
  
)

export default component.exports